import { ReportRecordFields } from '@tribeplatform/gql-client/graphql'
import type {
  AnalyticsResponse,
  QueryEventAnalyticsArgs,
} from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/index.js'
import { useTribeClient } from '../../useTribeClient.js'

import { getEventAnalyticsKey } from './event.key.js'

export const useEventAnalytics = (options: {
  variables: QueryEventAnalyticsArgs
  fields?: ReportRecordFields
  useQueryOptions?: UseQueryOptions<AnalyticsResponse>
}) => {
  const { variables, fields = 'basic', useQueryOptions } = options || {}
  const { client } = useTribeClient()
  const eventAnalyticsKey = getEventAnalyticsKey({ variables })

  return useQuery<AnalyticsResponse>(
    eventAnalyticsKey,
    () => client.events.eventAnalytics(variables, fields),
    useQueryOptions,
  )
}
